import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, UrlTree } from '@angular/router';
import { environment } from '@core/const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotProdGuard implements CanActivate, CanMatch {
  static guardName = 'NotProdGuard';

  canActivate(): Observable<boolean | UrlTree> | boolean {
    return !environment.production;
  }

  canMatch(): Observable<boolean | UrlTree> | boolean {
    return !environment.production;
  }
}
